var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// #style-inject:#style-inject
function styleInject(css, { insertAt } = {}) {
  if (!css || typeof document === "undefined")
    return;
  const head = document.head || document.getElementsByTagName("head")[0];
  const style = document.createElement("style");
  style.type = "text/css";
  if (insertAt === "top") {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

// src/style.css
styleInject(".xyz-wrapper {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  -webkit-backdrop-filter: blur(10px);\n  backdrop-filter: blur(10px);\n  background: unset;\n  background-color: rgba(0, 0, 0, 0.3);\n}\n.xyz-loader {\n  width: 48px;\n  height: 48px;\n  border: 3px solid var(--outline-color);\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  display: inline-block;\n  box-sizing: border-box;\n  animation: loader-rotate 1s linear infinite;\n}\n@keyframes loader-rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n");

// src/verification-sdk.ts
var isLocal = typeof window === "undefined" ? true : !!window.origin.includes("localhost");
var log = (...data) => {
  if (isLocal) {
    console.log(...data, "Local log");
  }
};
var iframe = document.createElement("iframe");
var isLoaded = false;
var BaseURL = "https://dd-rvp-sdk.vercel.app/";
var VerificationSDK = {
  onVerify: (data) => data,
  onClose: (data) => data,
  onLoad: (data) => data,
  onError: (error) => error,
  init: (method, config) => {
    var _b, _c;
    iframe.style = "border: 0; width: 100vw; height: 100vh; position: fixed; top: 0; left: 0; z-index:3000; overflow: hidden";
    iframe.allowTransparency = true;
    iframe.allow = `camera ${BaseURL}`;
    iframe.onload = () => {
      if (iframe.contentWindow) {
        const _a2 = config, { style, logErrors } = _a2, core = __objRest(_a2, ["style", "logErrors"]);
        const payload = {
          config: __spreadProps(__spreadValues({}, core), { successImage: style == null ? void 0 : style.successImage }),
          scope: "verification",
          method
        };
        setTimeout(() => {
          if (iframe.contentWindow) {
            iframe.contentWindow.postMessage(payload, BaseURL);
          }
        }, 1e3);
        isLoaded = true;
      }
    };
    window.addEventListener("message", (event) => {
      if (config.logErrors) {
        log(event.data);
      }
      if (event.data.type) {
        const { type } = event.data;
        if (type === "onVerify") {
          VerificationSDK.onVerify(event.data.data);
        }
        if (type === "closeModal") {
          if (document.contains(iframe)) {
            document.body.removeChild(iframe);
          }
          VerificationSDK.onClose(event.data.data);
        }
        if (type === "onLoad" && isLoaded) {
          VerificationSDK.onLoad(event.data.data);
        }
        if (type === "onError") {
          VerificationSDK.onError(event.data.data);
        }
        if (type === "onSupport") {
          if (VerificationSDK.onSupport) {
            VerificationSDK.onSupport(event.data);
          }
        }
        if (type === "appInitialized") {
          log("appInitialized", event.data);
        }
      }
    });
    if (method) {
      let valueToEncode;
      if (config.style) {
        const _a = config.style, { successImage } = _a, cleanStyle = __objRest(_a, ["successImage"]);
        valueToEncode = JSON.stringify(cleanStyle);
      } else {
        valueToEncode = JSON.stringify((_b = config == null ? void 0 : config.style) != null ? _b : {});
      }
      const style = encodeURIComponent(valueToEncode);
      const hasBVN = (_c = config == null ? void 0 : config.bvnStatus) != null ? _c : false;
      iframe.src = `${BaseURL}${method}?reference=${config.reference}&style=${style}&bhasbvn=${hasBVN}`;
      document.body.appendChild(iframe);
      if (VerificationSDK.onInit) {
        VerificationSDK.onInit();
      }
    }
  }
};
var verification_sdk_default = VerificationSDK;

// src/index.ts
var src_default = verification_sdk_default;
export {
  verification_sdk_default as VerificationSDK,
  src_default as default
};
